// This is the parent component of a modal: ModalDashboardenterpriseone

import {
  Button as AIMEButton,
  Input as AIMEInput,
} from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ReferAFriendPNG } from "./assets";
import GenericModal from "./GenericModal";
import ModalDashboardenterpriseone from "./ModalDashboardenterpriseone";
import { fetchOnboardingReferrals } from "./redux/slices/onboardingReferralsSlice";
import { fetchReferralHistoryItemsById } from "./redux/slices/ReferralHistoryThunk";
import { fetchReferralReward } from "./redux/slices/referralRewardsSlice";
import { fetchReferralsItemsByMemberID } from "./redux/slices/ReferralsThunks";
import ReferAFriendModal from "./ReferAFriendModal";
import ReferralCard from "./ReferralCard";
import { scrollToTop } from "./utils/func";
import CelebrationConfetti from "./prtnr/ui/CelebrationConfetti";

export default function Dashboardenterpriseone() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openReferAFriendModal, setOpenReferAFriendModal] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const member = JSON.parse(localStorage.getItem("member"));
  const closeModal = () => setIsModalOpen(false);
  const [history, setHistory] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [loading, setloading] = useState();
  const onViewReason = (item) => {
    navigate(`/myreferrals/${item._id}`, { state: { referral: item } });
    scrollToTop();
  };

  const referrals = useSelector((state) => state.referrals.items);
  const { list, error } = useSelector((state) => state.onboardingReferrals);
  const { rewardAmount } = useSelector((state) => state.referralRewards);

  const formattedDate = (date) => {
    const newDate = new Date(date);
    const formatted = newDate.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
    return formatted;
  };

  const tableHeadersFriendsReferred = [
    { label: "Friend Name", flex: 1 },
    { label: "Friend Email", flex: 1 },
    { label: "Reward", flex: 1 },
    { label: "Status", flex: 1 },
    { label: "Date Referred", flex: 1 },
  ];

  const tableColumnsFriendsReferred = [
    { key: "friend_name", flex: 1 },
    { key: "friend_email", flex: 1 },
    { key: "reward", flex: 1 },
    { key: "reward_status", flex: 1 },
    { key: "date_referred", flex: 1 },
  ];
  const tableHeaders = [
    { label: "Referral ID", width: "140px" },
    { label: "Date", flex: true },
    { label: "Potential Client's Website", width: "120px" },
    { label: "Vendor", flex: true },
    { label: "Status", width: "120px", type: "status" },
    { label: "Reward", width: "80px", align: "flex-end" },
    { label: "Action", width: "54px", align: "center" },
  ];

  const tableColumns = [
    { key: "referral_id", width: "140px" },
    { key: "date", flex: true },
    { key: "company_website_url", width: "120px" },
    { key: "vendor_name", flex: true },
    { key: "status", width: "130px", type: "status" },
    { key: "vendor_reward", width: "80px", align: "flex-end" },
    { key: "action", width: "54px", align: "center" },
  ];
  const [statusCounts, setStatusCounts] = useState({
    Successful: 0,
    Unsuccessful: 0,
    Tracking: 0,
    Paid: 0,
  });

  const [tableData, setTableData] = useState([]);

  const getReferrals = async () => {
    setloading(true);
    const res = await dispatch(fetchReferralsItemsByMemberID(member._id));

    var counts = {
      Successful: 0,
      Unsuccessful: 0,
      Tracking: 0,
      Paid: 0,
    };
    var arr = [];
    const data =
      res.payload.data.length > 0
        ? await Promise.all(
            res.payload.data.map(async (val, idx) => {
              counts[val.referral_member_status] += 1;

              const dispute = val.dispute;
              const history = await dispatch(
                fetchReferralHistoryItemsById(val._id)
              );

              if (history.payload.length > 0) {
                const updatedHistory = history.payload.map((item) => {
                  let action = item.action;

                  const { changes } = item;

                  // Extract referral_member_status change if it exists
                  if (changes?.includes("referral_member_status changed")) {
                    const match = changes.match(
                      /referral_member_status changed from '(.*?)' to '(.*?)'/
                    );
                    if (match) {
                      action = match[2];
                    }
                  }

                  return {
                    ...item,
                    vendor_name: val.vendor_id?.company_name,
                    vendor_reward: !isNaN(Number(totalReward))
                      ? Number(totalReward).toLocaleString("en-GB")
                      : "0",
                    action,
                  };
                });

                arr.push(...updatedHistory);
              }
              return {
                _id: val._id,
                referral_id: "R" + val._id.slice(-7),
                date: val?.created_at ? formattedDate(val?.created_at) : "",
                status: val.referral_member_status
                  ? val.referral_member_status
                  : "",
                industry_sector: val.industry_sector ? val.industry_sector : "",
                company_website_url: val?.company_website_url
                  ? val?.company_website_url
                  : " ",
                vendor_name: val.vendor_id?.company_name
                  ? val.vendor_id?.company_name
                  : " ",
                vendor: val.vendor_id,
                referral: val?.referral_id,
                is_urgent: val?.is_urgent,
                vendor_reward:
                  val?.reward != undefined
                    ? "£" + Number(val.reward)?.toLocaleString("en-GB")
                    : "-",
                dispute: val?.dispute
                  ? {
                      _id: val.dispute._id,
                      dispute_status: val.dispute.dispute_status,
                      explanation: val.dispute.explanation,
                      supporting_document: dispute.supporting_document,
                      created_at: formattedDate(val.dispute.date_raised),
                    }
                  : null,
              };
            })
          )
        : [];

    setHistory(arr);
    setStatusCounts(counts);
    setloading(false);
    setTableData(data);
  };

  const totalReward = referrals
    ?.filter(
      (item) =>
        item.referral_member_status === "Successful" ||
        item.referral_member_status === "Paid"
    )
    .reduce((sum, item) => {
      const reward = parseFloat(item.reward || 0);

      return sum + reward;
    }, 0);
  useEffect(() => {
    getReferrals();
  }, []);

  useEffect(() => {
    dispatch(fetchOnboardingReferrals());
    dispatch(fetchReferralReward());
  }, [dispatch]);

  const filteredHistory = history
    ?.filter(
      (item) =>
        ![
          "Lead Identified",
          "Opportunity",
          "Proposal Sent",
          "Verbally Committed",
          "Won",
          "Lost",
          "Referral updated",
        ].includes(item.action)
    )
    .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at)); // newest first

  const displayedHistory = showAll
    ? filteredHistory
    : filteredHistory.slice(0, 4);

  const latestFive = useMemo(() => {
    if (!tableData?.length) return [];

    return tableData
      .slice() // clone to avoid mutating original
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      .slice(0, 5);
  }, [tableData]);
  return (
    <RootWrapperDashboardenterpriseone>
      <Dashboard>
        <Wrapper>
          <DashboardHeader>
            <Frame1462>
              <WelcomeJames>
                Welcome {member?.first_name + " " + member?.last_name}
              </WelcomeJames>
              <KeepReferringAndEarningRewardsCheckYouStatsBelow>
                Keep referring and earning rewards. Check your stats below.
              </KeepReferringAndEarningRewardsCheckYouStatsBelow>
            </Frame1462>
          </DashboardHeader>
          <QuickAnalytics>
            <Frame1425>
              <Frame1422>
                <PRTNR.StatusBadge />
                <Frame1429>
                  <TotalEarnings>Total Earnings</TotalEarnings>
                  <_1250>
                    £
                    {!isNaN(Number(totalReward))
                      ? Number(totalReward).toLocaleString("en-GB")
                      : "0"}
                  </_1250>
                </Frame1429>
              </Frame1422>
            </Frame1425>
            <Frame1425>
              <Frame1422>
                <PRTNR.StatusBadge status={"Successful"} />
                <Frame1429>
                  <TotalEarnings>Successful</TotalEarnings>
                  <_1250>
                    {(statusCounts["Successful"] || 0) +
                      (statusCounts["Paid"] || 0)}
                  </_1250>
                </Frame1429>
              </Frame1422>
            </Frame1425>
            <Frame1425>
              <Frame1422>
                <PRTNR.StatusBadge status={"Tracking"} />
                <Frame1429>
                  <TotalEarnings>Tracking</TotalEarnings>
                  <_1250>{statusCounts["Tracking"] || 0}</_1250>
                </Frame1429>
              </Frame1422>
            </Frame1425>
            <Frame1425>
              <Frame1422>
                <PRTNR.StatusBadge status={"Unsuccessful"} />
                <Frame1429>
                  <TotalEarnings>Unsuccessful</TotalEarnings>
                  <_1250>{statusCounts["Unsuccessful"] || 0}</_1250>
                </Frame1429>
              </Frame1422>
            </Frame1425>
          </QuickAnalytics>
          <DashboardData>
            <Left_0001>
              <CardWrapper>
                <Frame1433>
                  <Frame1431>
                    <Referrals>Referrals </Referrals>
                  </Frame1431>
                </Frame1433>
                {latestFive.map((item, index) => (
                  <ReferralCard key={index} item={item} />
                ))}
                <Frame1461>
                  <AIMEButton
                    size="small"
                    onClick={() => {
                      navigate("/myreferrals");
                      scrollToTop();
                    }}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      borderRadius: "999px",
                      width: "168px",
                      height: "36px",
                      background: "rgb(241, 245, 249)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "8px 16px",
                    }}
                  >
                    <span
                      style={{
                        color: "rgb(33, 37, 67)",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "140%",
                        textAlign: "left",
                      }}
                    >
                      View all
                    </span>
                  </AIMEButton>
                </Frame1461>
              </CardWrapper>
              <RecentReferrals>
                <Frame1433>
                  <Frame1431>
                    <Referrals>Referrals </Referrals>
                  </Frame1431>
                </Frame1433>
                <ScrollContainer>
                  <PRTNR.TableComponent
                    onViewReason={onViewReason}
                    tableHeaders={tableHeaders}
                    tableColumns={tableColumns}
                    tableData={latestFive}
                    loading={loading}
                  />
                </ScrollContainer>

                <Frame1461>
                  <AIMEButton
                    size="small"
                    onClick={() => {
                      navigate("/myreferrals");
                      scrollToTop();
                    }}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      borderRadius: "999px",
                      width: "168px",
                      height: "36px",
                      background: "rgb(241, 245, 249)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "8px 16px",
                    }}
                  >
                    <span
                      style={{
                        color: "rgb(33, 37, 67)",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "140%",
                        textAlign: "left",
                      }}
                    >
                      View all
                    </span>
                  </AIMEButton>
                </Frame1461>
              </RecentReferrals>
              <FriendsReferred>
                <Frame1433>
                  <Frame1431_0001>
                    <Frame1431_0004>
                      <FriendsReferred_0001>
                        Friends Referred
                      </FriendsReferred_0001>
                    </Frame1431_0004>
                  </Frame1431_0001>
                  <Frame1432>
                    <GFieldsStacked>
                      <GFieldsStacked_0001>
                        <AIMEInput type="text" placeholder="All" />
                      </GFieldsStacked_0001>
                    </GFieldsStacked>
                  </Frame1432>
                </Frame1433>
                <ScrollContainer>
                  <PRTNR.TableComponent
                    onViewReason={onViewReason}
                    tableHeaders={tableHeadersFriendsReferred}
                    tableColumns={tableColumnsFriendsReferred}
                    tableData={list?.slice(0, 4)}
                    // tableData={list}
                  />
                </ScrollContainer>
                <Frame1461>
                  <AIMEButton
                    size="small"
                    onClick={() => navigate("/referafriendone")}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      borderRadius: "999px",
                      width: "168px",
                      height: "36px",
                      background: "rgb(241, 245, 249)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "8px 16px",
                    }}
                  >
                    <span
                      style={{
                        color: "rgb(33, 37, 67)",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "140%",
                        textAlign: "left",
                      }}
                    >
                      View all
                    </span>
                  </AIMEButton>
                </Frame1461>
              </FriendsReferred>
            </Left_0001>
            <Right>
              <ActivityNotification>
                <Frame1433_0003>
                  <Frame1433_0004>
                    <RecentActivity>Recent Activity</RecentActivity>
                  </Frame1433_0004>
                </Frame1433_0003>
                <ActivityScrollContainer>
                  {[...displayedHistory]
                    .sort(
                      (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
                    )
                    .map((val, idx) => (
                      <React.Fragment key={idx}>
                        <PRTNR.HistoryValues
                          status={val.action}
                          vendor={val.vendor_name}
                          date={val.updated_at}
                          reward={val?.vendor_reward}
                        />
                        <Seperator />
                      </React.Fragment>
                    ))}
                </ActivityScrollContainer>
                {filteredHistory.length > 0 && (
                  <Frame1437>
                    <LinkButton>
                      <AIMEButton
                        size="small"
                        onClick={() => setShowAll((prev) => !prev)}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "row",
                          alignItems: "center",
                          flex: "none",
                          gap: "4px",
                          borderRadius: "4px",
                          boxSizing: "border-box",
                          padding: "8px 12px",
                          background: "transparent",
                          "&:hover": { background: "transparent" },
                        }}
                      >
                        <span
                          style={{
                            color: "rgb(97, 98, 197)",
                            textOverflow: "ellipsis",
                            fontSize: "14px",
                            fontFamily: "Montserrat, sans-serif",
                            fontWeight: "600",
                            lineHeight: "140%",
                            textAlign: "left",
                          }}
                        >
                          {showAll ? "View less" : "View all"}
                        </span>
                      </AIMEButton>
                    </LinkButton>
                  </Frame1437>
                )}
              </ActivityNotification>
              <Frame1464>
                <FriendsSvg>
                  <img src={ReferAFriendPNG} alt="Refer a Friend" />
                </FriendsSvg>
                <ReferAFriend>Refer a Friend</ReferAFriend>
                <GetMoreRewardsByRefering>
                  {rewardAmount
                    ? `Refer a friend and earn a reward of £${rewardAmount}!`
                    : "Get more rewards by referring"}
                </GetMoreRewardsByRefering>

                <AIMEButton
                  size="small"
                  onClick={() => setOpenReferAFriendModal(true)}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    borderRadius: "999px",
                    background: "rgb(241, 245, 249)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "8px 16px",
                    width: "124px",
                    "&:hover": {
                      background: "rgb(241, 245, 249)",
                      opacity: "0.9",
                    },
                  }}
                >
                  <span
                    style={{
                      color: "rgb(33, 37, 67)",
                      textOverflow: "ellipsis",
                      fontSize: "14px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "140%",
                      textAlign: "left",
                    }}
                  >
                    Refer Now!
                  </span>
                </AIMEButton>
              </Frame1464>
            </Right>
          </DashboardData>
        </Wrapper>
      </Dashboard>

      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        <ModalDashboardenterpriseone
          isOpen={isModalOpen}
          onClose={closeModal}
        />
      </GenericModal>
      <GenericModal
        isOpen={openReferAFriendModal}
        onClose={() => setOpenReferAFriendModal(false)}
      >
        <ReferAFriendModal
          isOpen={openReferAFriendModal}
          onClose={() => setOpenReferAFriendModal(false)}
        />
      </GenericModal>
    </RootWrapperDashboardenterpriseone>
  );
}

const RootWrapperDashboardenterpriseone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  /* min-height: 100vh; */
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Dashboard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(0.5rem, 1vw, 1rem);
  width: 100%;
  padding-inline: clamp(1rem, 5vw, 3.75rem);
  background: rgba(241, 245, 249, 1);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  box-sizing: border-box;
  flex-shrink: 0;
  /* min-height: 100vh; */
`;
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 0px 32px;
  flex-shrink: 0;
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  gap: 8px;
  box-sizing: border-box;
  padding: 32px 0px;
  flex-shrink: 0;
`;

const Frame1462 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  flex: 1;
  gap: 4px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const WelcomeJames = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(1.5rem, 5vw, 3rem);
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: clamp(-0.03rem, -0.05vw, -0.06rem);
  text-align: left;
  @media (max-width: 768px) {
    white-space: normal; /* allow wrapping on smaller screens */
  }
`;

const KeepReferringAndEarningRewardsCheckYouStatsBelow = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(0.875rem, 2.5vw, 1.125rem);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  @media (max-width: 768px) {
    white-space: normal; /* allow wrapping on smaller screens */
  }
`;

const QuickAnalytics = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  box-sizing: border-box;
  flex-shrink: 0;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  flex-wrap: wrap;
`;

const Frame1425 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1 calc(25% - 12px); /* 4 per row on desktop */
  box-sizing: border-box;
  min-width: 240px;

  @media (max-width: 1024px) {
    flex: 1 1 calc(50% - 8px); /* 2 per row on tablet */
    min-width: 140px;
  }

  @media (max-width: 600px) {
    flex: 1 1 calc(50% - 8px); /* Still 2 per row on small phones */
    min-width: 140px;
  }
`;

const Frame1422 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
  flex: 1;
`;

const Frame1429 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
`;

const TotalEarnings = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2.5vw, 18px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const _1250 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(20px, 4vw, 30px);
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
  word-break: break-word;
`;

const DashboardData = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 24px 0px;
  flex-shrink: 0;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  @media (max-width: 1200px) and (min-width: 768px) {
    width: 100%;
    flex-wrap: wrap;
  }

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

const Left_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 16px;
  flex: 2;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const CardWrapper = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex; /* Show cards only on mobile */
    flex-direction: column;
    gap: 16px;
    width: 100%;
    box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
    border: solid 1px rgb(225, 228, 234);
    border-radius: 16px;
    background: rgb(255, 255, 255);
    padding: 16px;
    box-sizing: border-box;
  }
`;

const RecentReferrals = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
  width: 100%;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Frame1433 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  flex-wrap: wrap;
`;

const Frame1431 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  box-sizing: border-box;
`;

const Referrals = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  flex: 1;
`;

const Frame1461 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const ScrollContainer = styled.div`
  overflow-x: auto;
  width: 100%;
  -webkit-overflow-scrolling: touch; /* smooth scrolling on iOS */

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
  }
`;

const Frame1431_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: 1;
`;

const Frame1432 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const GFieldsStacked = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
`;

const GFieldsStacked_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 4px;
  box-sizing: border-box;
`;

const FriendsReferred = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
  width: 100%;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const Frame1431_0004 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  box-sizing: border-box;
`;

const FriendsReferred_0001 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  flex: 1;
`;

const Right = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 16px;
  width: 300px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const ActivityNotification = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px 0px;
  flex-shrink: 0;
  width: 100%;

  @media (max-width: 768px) {
    padding: 16px 0px;
  }
`;

const Frame1433_0003 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
  padding: 0px 24px;

  @media (max-width: 768px) {
    padding: 0px 16px;
  }
`;

const Frame1433_0004 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  width: 100%;
  box-sizing: border-box;
`;

const RecentActivity = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 100%;
  min-height: 29px;
  flex: 1;
`;

const Frame1437 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const LinkButton = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Frame1464 = styled.div`
  min-height: 220px;
  overflow: hidden;
  background: linear-gradient(
    -225deg,
    rgb(145, 202, 242),
    rgb(66, 187, 173),
    rgb(96, 197, 135)
  );
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  border-radius: 16px;
  position: relative;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.1);
  align-self: stretch;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 16px;
  gap: 8px;

  @media (max-width: 768px) {
    min-height: 180px;
    padding: 20px 12px;
  }
`;

const ReferAFriend = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: clamp(20px, 4vw, 30px);
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: center;
  word-break: break-word;
`;

const GetMoreRewardsByRefering = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: clamp(12px, 2vw, 14px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  margin-bottom: 6px;
  padding: 0 8px;
  word-break: break-word;
`;

const FriendsSvg = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const Seperator = styled.div`
  height: 1px;
  background-color: rgba(136, 136, 136, 0.1);
  width: 100%;
`;

const ActivityScrollContainer = styled.div`
  max-height: 500px;
  overflow-y: auto;
  padding: 16px 24px;
  width: 100%;
  -webkit-overflow-scrolling: touch;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 768px) {
    max-height: 400px;
    padding: 12px 16px;
  }

  @media (max-width: 480px) {
    max-height: 350px;
    padding: 8px 12px;
  }
`;
